import { render, staticRenderFns } from "./applicantLanguage.vue?vue&type=template&id=153df48a&scoped=true"
import script from "./applicantLanguage.vue?vue&type=script&lang=js"
export * from "./applicantLanguage.vue?vue&type=script&lang=js"
import style0 from "./applicantLanguage.vue?vue&type=style&index=0&id=153df48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153df48a",
  null
  
)

export default component.exports